import {collection, doc, getDoc, getDocs, getFirestore, serverTimestamp, setDoc} from "firebase/firestore";

export async function readAllTags() {

  const firestore = getFirestore(window.firebaseApp)
  const querySnapshot =
    await getDocs(collection(firestore, "tags"));

  const docs = []
  querySnapshot.forEach((doc) => {
    docs.push(doc.data())
  });
  return docs;
}

export async function writeTag(tag, songIDs) {

  const firestore = getFirestore(window.firebaseApp)
  const docRef = doc(firestore, "tags", tag)

  let snapshot = null;
  let useMerge = !navigator.onLine;
  if (navigator.onLine) {
    try {
      snapshot = await getDoc(docRef);
    } catch (error) {
      // A transient read failure must not prevent a queued write.
      if (error?.code === "unavailable" || error?.code === "failed-precondition") {
        useMerge = true;
      } else {
        throw error;
      }
    }
  }

  const data = {
    name: tag,
    songIDs,
    updatedBy: window.firebaseUser.uid,
    updatedAt: serverTimestamp(),
  };

  if (!useMerge) {
    if (snapshot?.exists()) {
      const existing = snapshot.data();
      data.createdAt = existing.createdAt ?? serverTimestamp();
      data.createdBy = existing.createdBy ?? window.firebaseUser.uid;
    } else {
      data.createdAt = serverTimestamp();
      data.createdBy = window.firebaseUser.uid;
    }
  }

  await setDoc(docRef, data, {merge: useMerge});
}
